import * as INR from "../INR.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import ApiServer from "../ApiServer.ts";
import FizConfig from "../FizConfig.ts";
import * as libLocation from "../lib/location.ts";
import * as Confetti from "../lib/Confetti.ts";
import * as Storage from "../lib/Storage.ts";
import {OS} from "../lib/os.ts";
import deviceId from "../lib/deviceId.ts";
import {openStorageAlert} from "../modal/storageAlert.ts";
import * as ga from "../tracking-googleanalytics.ts";
import * as FeatureSeen from "../util/FeatureSeen.ts";
import {displayPromoPopupIfNeeded} from "../ui/specific-family.ts";

INR.onPage(INR.URL.ENTER_HOME,async function(){

  if(libLocation.getURLParam("modal")==="welcome"){
    Confetti.start(2000);
    libLocation.clearParamInHistory()
    var [TPL_INVITE,TPL] = await Promise.all([import("../modal/welcome-invite.mustache"),import("../modal/welcome.mustache")])
    await modal.askAsPromiseTpl(TPL)
    await modal.askAsPromiseTpl(TPL_INVITE)

    displayPromoPopupIfNeeded()


  }else if(libLocation.getURLParam("modal")==="promocode"){
    libLocation.clearParamInHistory()
    import("../modal/congratulations.mustache").then(function(TPL){
      Confetti.start(2000);
      modal.openDomModal(TPL)
    });
  }else if(libLocation.getURLParam("from")==="2checkout"){

    Storage.sessionSet('waitingpremium',(new Date()).toISOString())

    import("../modal/waitingpremium.mustache").then(function(TPL){
      var
        waitingModal = modal.openDomModal(TPL),
        pollCount = 0,
        interval = setInterval(function(){
        ApiServer.accgetstate(deviceId, "WebFirebase", FizConfig.VERSION||"", function(accountState: any) {
          if(accountState.premium.fWPremiumMemberSubscriber){
            clearInterval(interval)
            modal.closeDomModal(waitingModal)
            premiumGetted()
          }else if(pollCount++>30){
            clearInterval(interval)
            modal.closeDomModal(waitingModal)
            modal.oops("modalcongratulations.waitingerror")
          }
          FwDatas.setState(accountState);
        },function(err: any){console.log(err)});
      },1000);
    })
    function premiumGetted(): void {
      import("../modal/congratulations.mustache").then(function(TPL){
        ga.event({
          'event': 'startedPremiumTrial',
          'form_name': 'premium trial form'
          });
        Confetti.start(2000);
        function displayDeepLink(data: any): void {
          const theModal = modal.openDomModal(TPL,{deepLoginLink:data});
          theModal.onClose = function(){libLocation.clearParamInHistory();}
        }
        function display(data?: any): void {
          const theModal = modal.openDomModal(TPL);
          theModal.onClose = function(){libLocation.clearParamInHistory();}
        }

        if(OS.hasApp){
          ApiServer.accdeeplink(OS.isAndroid?'home':'myfamily',displayDeepLink,display);
        }else{
          display()
        }

      });
    }

  }else if(libLocation.getURLParam("result")==="200"){
    libLocation.clearParamInHistory();
    openStorageAlert(true)

    displayPromoPopupIfNeeded()
  }
  if(!FeatureSeen.hasSeen('newfeatures.specialdays')){
    FeatureSeen.markSeen('newfeatures.specialdays');
    modal.openDomModal(await import('../specialdays/modal_specialdays_intro.mustache'))
  }
});

